(window.webpackJsonp=window.webpackJsonp||[]).push([[6],{
/***/"6hLg":
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return u}));
/* harmony import */n("SRZj");
/* harmony import */var o=n("9yD6"),i=n("Y40L"),s=n("MDMB");
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/**
 * Returns true if `node` is a slot element
 * @param {!Node} node Node to test.
 * @return {boolean} Returns true if the given `node` is a slot
 * @private
 */
function r(t){return"slot"===t.localName}
/**
 * Class that listens for changes (additions or removals) to
 * "flattened nodes" on a given `node`. The list of flattened nodes consists
 * of a node's children and, for any children that are `<slot>` elements,
 * the expanded flattened list of `assignedNodes`.
 * For example, if the observed node has children `<a></a><slot></slot><b></b>`
 * and the `<slot>` has one `<div>` assigned to it, then the flattened
 * nodes list is `<a></a><div></div><b></b>`. If the `<slot>` has other
 * `<slot>` elements assigned to it, these are flattened as well.
 *
 * The provided `callback` is called whenever any change to this list
 * of flattened nodes occurs, where an addition or removal of a node is
 * considered a change. The `callback` is called with one argument, an object
 * containing an array of any `addedNodes` and `removedNodes`.
 *
 * Note: the callback is called asynchronous to any changes
 * at a microtask checkpoint. This is because observation is performed using
 * `MutationObserver` and the `<slot>` element's `slotchange` event which
 * are asynchronous.
 *
 * An example:
 * ```js
 * class TestSelfObserve extends PolymerElement {
 *   static get is() { return 'test-self-observe';}
 *   connectedCallback() {
 *     super.connectedCallback();
 *     this._observer = new FlattenedNodesObserver(this, (info) => {
 *       this.info = info;
 *     });
 *   }
 *   disconnectedCallback() {
 *     super.disconnectedCallback();
 *     this._observer.disconnect();
 *   }
 * }
 * customElements.define(TestSelfObserve.is, TestSelfObserve);
 * ```
 *
 * @summary Class that listens for changes (additions or removals) to
 * "flattened nodes" on a given `node`.
 * @implements {PolymerDomApi.ObserveHandle}
 */let u=class{
/**
   * Returns the list of flattened nodes for the given `node`.
   * This list consists of a node's children and, for any children
   * that are `<slot>` elements, the expanded flattened list of `assignedNodes`.
   * For example, if the observed node has children `<a></a><slot></slot><b></b>`
   * and the `<slot>` has one `<div>` assigned to it, then the flattened
   * nodes list is `<a></a><div></div><b></b>`. If the `<slot>` has other
   * `<slot>` elements assigned to it, these are flattened as well.
   *
   * @param {!HTMLElement|!HTMLSlotElement} node The node for which to
   *      return the list of flattened nodes.
   * @return {!Array<!Node>} The list of flattened nodes for the given `node`.
   * @nocollapse See https://github.com/google/closure-compiler/issues/2763
   */
// eslint-disable-next-line
static getFlattenedNodes(t){const e=Object(s.a)(t);return r(t)?(t=
/** @type {!HTMLSlotElement} */
t,e.assignedNodes({flatten:!0})):Array.from(e.childNodes).map(t=>r(t)?(t=
/** @type {!HTMLSlotElement} */
t,Object(s.a)(t).assignedNodes({flatten:!0})):[t]).reduce((t,e)=>t.concat(e),[])}
/**
   * @param {!HTMLElement} target Node on which to listen for changes.
   * @param {?function(this: Element, { target: !HTMLElement, addedNodes: !Array<!Element>, removedNodes: !Array<!Element> }):void} callback Function called when there are additions
   * or removals from the target's list of flattened nodes.
   */
// eslint-disable-next-line
constructor(t,e){
/**
     * @type {MutationObserver}
     * @private
     */
this._shadyChildrenObserver=null,
/**
     * @type {MutationObserver}
     * @private
     */
this._nativeChildrenObserver=null,this._connected=!1,
/**
     * @type {!HTMLElement}
     * @private
     */
this._target=t,this.callback=e,this._effectiveNodes=[],this._observer=null,this._scheduled=!1,
/**
     * @type {function()}
     * @private
     */
this._boundSchedule=()=>{this._schedule()},this.connect(),this._schedule()}
/**
   * Activates an observer. This method is automatically called when
   * a `FlattenedNodesObserver` is created. It should only be called to
   * re-activate an observer that has been deactivated via the `disconnect` method.
   *
   * @return {void}
   */connect(){r(this._target)?this._listenSlots([this._target]):Object(s.a)(this._target).children&&(this._listenSlots(
/** @type {!NodeList<!Node>} */
Object(s.a)(this._target).children),window.ShadyDOM?this._shadyChildrenObserver=window.ShadyDOM.observeChildren(this._target,t=>{this._processMutations(t)}):(this._nativeChildrenObserver=new MutationObserver(t=>{this._processMutations(t)}),this._nativeChildrenObserver.observe(this._target,{childList:!0}))),this._connected=!0}
/**
   * Deactivates the flattened nodes observer. After calling this method
   * the observer callback will not be called when changes to flattened nodes
   * occur. The `connect` method may be subsequently called to reactivate
   * the observer.
   *
   * @return {void}
   * @override
   */disconnect(){r(this._target)?this._unlistenSlots([this._target]):Object(s.a)(this._target).children&&(this._unlistenSlots(
/** @type {!NodeList<!Node>} */
Object(s.a)(this._target).children),window.ShadyDOM&&this._shadyChildrenObserver?(window.ShadyDOM.unobserveChildren(this._shadyChildrenObserver),this._shadyChildrenObserver=null):this._nativeChildrenObserver&&(this._nativeChildrenObserver.disconnect(),this._nativeChildrenObserver=null)),this._connected=!1}
/**
   * @return {void}
   * @private
   */_schedule(){this._scheduled||(this._scheduled=!0,i.c.run(()=>this.flush()))}
/**
   * @param {Array<MutationRecord>} mutations Mutations signaled by the mutation observer
   * @return {void}
   * @private
   */_processMutations(t){this._processSlotMutations(t),this.flush()}
/**
   * @param {Array<MutationRecord>} mutations Mutations signaled by the mutation observer
   * @return {void}
   * @private
   */_processSlotMutations(t){if(t)for(let e=0;e<t.length;e++){let n=t[e];n.addedNodes&&this._listenSlots(n.addedNodes),n.removedNodes&&this._unlistenSlots(n.removedNodes)}}
/**
   * Flushes the observer causing any pending changes to be immediately
   * delivered the observer callback. By default these changes are delivered
   * asynchronously at the next microtask checkpoint.
   *
   * @return {boolean} Returns true if any pending changes caused the observer
   * callback to run.
   */flush(){if(!this._connected)return!1;window.ShadyDOM&&ShadyDOM.flush(),this._nativeChildrenObserver?this._processSlotMutations(this._nativeChildrenObserver.takeRecords()):this._shadyChildrenObserver&&this._processSlotMutations(this._shadyChildrenObserver.takeRecords()),this._scheduled=!1;let t={target:this._target,addedNodes:[],removedNodes:[]},e=this.constructor.getFlattenedNodes(this._target),n=Object(o.a)(e,this._effectiveNodes);// process removals
for(let e,o=0;o<n.length&&(e=n[o]);o++)for(let n,o=0;o<e.removed.length&&(n=e.removed[o]);o++)t.removedNodes.push(n);// process adds
for(let o,i=0;i<n.length&&(o=n[i]);i++)for(let n=o.index;n<o.index+o.addedCount;n++)t.addedNodes.push(e[n]);// update cache
this._effectiveNodes=e;let i=!1;return(t.addedNodes.length||t.removedNodes.length)&&(i=!0,this.callback.call(this._target,t)),i}
/**
   * @param {!Array<!Node>|!NodeList<!Node>} nodeList Nodes that could change
   * @return {void}
   * @private
   */_listenSlots(t){for(let e=0;e<t.length;e++){let n=t[e];r(n)&&n.addEventListener("slotchange",this._boundSchedule)}}
/**
   * @param {!Array<!Node>|!NodeList<!Node>} nodeList Nodes that could change
   * @return {void}
   * @private
   */_unlistenSlots(t){for(let e=0;e<t.length;e++){let n=t[e];r(n)&&n.removeEventListener("slotchange",this._boundSchedule)}}};
/***/},
/***/"9nmN":
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return o})),
/* harmony export (binding) */n.d(e,"b",(function(){return s})),
/* harmony export (binding) */n.d(e,"c",(function(){return r}));
/* harmony import */n("SRZj"),n("dv22"),n("Y40L")
/* harmony import */;
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/**
 * @summary Collapse multiple callbacks into one invocation after a timer.
 */
class o{constructor(){this._asyncModule=null,this._callback=null,this._timer=null}
/**
   * Sets the scheduler; that is, a module with the Async interface,
   * a callback and optional arguments to be passed to the run function
   * from the async module.
   *
   * @param {!AsyncInterface} asyncModule Object with Async interface.
   * @param {function()} callback Callback to run.
   * @return {void}
   */setConfig(t,e){this._asyncModule=t,this._callback=e,this._timer=this._asyncModule.run(()=>{this._timer=null,i.delete(this),this._callback()})}
/**
   * Cancels an active debouncer and returns a reference to itself.
   *
   * @return {void}
   */cancel(){this.isActive()&&(this._cancelAsync(),// Canceling a debouncer removes its spot from the flush queue,
// so if a debouncer is manually canceled and re-debounced, it
// will reset its flush order (this is a very minor difference from 1.x)
// Re-debouncing via the `debounce` API retains the 1.x FIFO flush order
i.delete(this))}
/**
   * Cancels a debouncer's async callback.
   *
   * @return {void}
   */_cancelAsync(){this.isActive()&&(this._asyncModule.cancel(
/** @type {number} */
this._timer),this._timer=null)}
/**
   * Flushes an active debouncer and returns a reference to itself.
   *
   * @return {void}
   */flush(){this.isActive()&&(this.cancel(),this._callback())}
/**
   * Returns true if the debouncer is active.
   *
   * @return {boolean} True if active.
   */isActive(){return null!=this._timer}
/**
   * Creates a debouncer if no debouncer is passed as a parameter
   * or it cancels an active debouncer otherwise. The following
   * example shows how a debouncer can be called multiple times within a
   * microtask and "debounced" such that the provided callback function is
   * called once. Add this method to a custom element:
   *
   * ```js
   * import {microTask} from '@polymer/polymer/lib/utils/async.js';
   * import {Debouncer} from '@polymer/polymer/lib/utils/debounce.js';
   * // ...
   *
   * _debounceWork() {
   *   this._debounceJob = Debouncer.debounce(this._debounceJob,
   *       microTask, () => this._doWork());
   * }
   * ```
   *
   * If the `_debounceWork` method is called multiple times within the same
   * microtask, the `_doWork` function will be called only once at the next
   * microtask checkpoint.
   *
   * Note: In testing it is often convenient to avoid asynchrony. To accomplish
   * this with a debouncer, you can use `enqueueDebouncer` and
   * `flush`. For example, extend the above example by adding
   * `enqueueDebouncer(this._debounceJob)` at the end of the
   * `_debounceWork` method. Then in a test, call `flush` to ensure
   * the debouncer has completed.
   *
   * @param {Debouncer?} debouncer Debouncer object.
   * @param {!AsyncInterface} asyncModule Object with Async interface
   * @param {function()} callback Callback to run.
   * @return {!Debouncer} Returns a debouncer object.
   */static debounce(t,e,n){return t instanceof o?
// Cancel the async callback, but leave in debouncerQueue if it was
// enqueued, to maintain 1.x flush order
t._cancelAsync():t=new o,t.setConfig(e,n),t}}let i=new Set;
/**
 * Adds a `Debouncer` to a list of globally flushable tasks.
 *
 * @param {!Debouncer} debouncer Debouncer to enqueue
 * @return {void}
 */const s=function(t){i.add(t)},r=function(){const t=Boolean(i.size);// If new debouncers are added while flushing, Set.forEach will ensure
// newly added ones are also flushed
return i.forEach(t=>{try{t.flush()}catch(t){setTimeout(()=>{throw t})}}),t};
/**
 * Flushes any enqueued debouncers
 *
 * @return {boolean} Returns whether any debouncers were flushed
 */},
/***/BTBx:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"b",(function(){return r})),
/* harmony export (binding) */n.d(e,"a",(function(){return u}));
/* harmony import */n("SRZj");
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/const o={},i=/-[a-z]/g,s=/([A-Z])/g;
/**
 * @fileoverview Module with utilities for converting between "dash-case" and
 * "camelCase" identifiers.
 */
/**
 * Converts "dash-case" identifier (e.g. `foo-bar-baz`) to "camelCase"
 * (e.g. `fooBarBaz`).
 *
 * @param {string} dash Dash-case identifier
 * @return {string} Camel-case representation of the identifier
 */
function r(t){return o[t]||(o[t]=t.indexOf("-")<0?t:t.replace(i,t=>t[1].toUpperCase()))}
/**
 * Converts "camelCase" identifier (e.g. `fooBarBaz`) to "dash-case"
 * (e.g. `foo-bar-baz`).
 *
 * @param {string} camel Camel-case identifier
 * @return {string} Dash-case representation of the identifier
 */function u(t){return o[t]||(o[t]=t.replace(s,"-$1").toLowerCase())}
/***/},
/***/LtGt:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return s}));
/* harmony import */var o=n("H/aU");
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/**
 * @fileoverview
 *
 * Module to hide `<dom-bind>`, `<dom-if>`, and `<dom-repeat>` elements
 * optimally in ShadyDOM
 */let i=!1;
/**
 * @return {boolean} True if elements will be hidden globally
 */function s(){if(o.e&&!o.s){if(!i){i=!0;const t=document.createElement("style");t.textContent="dom-bind,dom-if,dom-repeat{display:none;}",document.head.appendChild(t)}return!0}return!1}
/***/},
/***/SRZj:
/***/function(t,e,n){"use strict";
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/* eslint-disable no-unused-vars */
/**
 * When using Closure Compiler, JSCompiler_renameProperty(property, object) is replaced by the munged name for object[property]
 * We cannot alias this function, so we have to use a small shim that has the same behavior when not compiling.
 *
 * @param {?} prop Property name
 * @param {*} obj Reference object
 * @return {string} Potentially renamed property name
 */window.JSCompiler_renameProperty=function(t,e){return t}},
/***/WE4f:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"b",(function(){return i}));
/* harmony import */n("SRZj");
/* harmony import */var o=n("9nmN");
/* harmony reexport (safe) */n.d(e,"a",(function(){return o.b}));
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/**
 * Forces several classes of asynchronously queued tasks to flush:
 * - Debouncers added via `enqueueDebouncer`
 * - ShadyDOM distribution
 *
 * @return {void}
 */
const i=function(){let t,e;do{t=window.ShadyDOM&&ShadyDOM.flush(),window.ShadyCSS&&window.ShadyCSS.ScopingShim&&window.ShadyCSS.ScopingShim.flush(),e=Object(o.c)()}while(t||e)};
/***/},
/***/dv22:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return s}));
/* harmony import */n("SRZj");
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
// unique global id for deduping mixins.
let o=0;
/**
 * @constructor
 * @extends {Function}
 * @private
 */function i(){}
/** @type {(WeakMap | undefined)} */i.prototype.__mixinApplications,
/** @type {(Object | undefined)} */
i.prototype.__mixinSet;
/* eslint-disable valid-jsdoc */
/**
 * Wraps an ES6 class expression mixin such that the mixin is only applied
 * if it has not already been applied its base argument. Also memoizes mixin
 * applications.
 *
 * @template T
 * @param {T} mixin ES6 class expression mixin to wrap
 * @return {T}
 * @suppress {invalidCasts}
 */
const s=function(t){let e=
/** @type {!MixinFunction} */
t.__mixinApplications;e||(e=new WeakMap,
/** @type {!MixinFunction} */
t.__mixinApplications=e);// maintain a unique id for each mixin
let n=o++;return function(o){let i=
/** @type {!MixinFunction} */
o.__mixinSet;if(i&&i[n])return o;let s=e,r=s.get(o);if(!r){r=
/** @type {!Function} */
t(o),s.set(o,r);// copy inherited mixin set from the extended class, or the base class
// NOTE: we avoid use of Set here because some browser (IE11)
// cannot extend a base Set via the constructor.
let e=Object.create(
/** @type {!MixinFunction} */
r.__mixinSet||i||null);e[n]=!0,
/** @type {!MixinFunction} */
r.__mixinSet=e}return r}};
/* eslint-enable valid-jsdoc */
/***/},
/***/hLn4:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"b",(function(){return k})),
/* unused harmony export recognizers */
/* unused harmony export deepTargetFind */
/* harmony export (binding) */n.d(e,"a",(function(){return D})),
/* harmony export (binding) */n.d(e,"e",(function(){return j})),
/* harmony export (binding) */n.d(e,"d",(function(){return T})),
/* harmony export (binding) */n.d(e,"g",(function(){return Y})),
/* harmony export (binding) */n.d(e,"c",(function(){return X})),
/* harmony export (binding) */n.d(e,"f",(function(){return P}));
/* unused harmony export findOriginalTarget */
/* unused harmony export add */
/* unused harmony export remove */
/* harmony import */n("SRZj");
/* harmony import */var o=n("Y40L"),i=n("9nmN"),s=n("H/aU"),r=n("MDMB");
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/**
 * @fileoverview
 *
 * Module for adding listeners to a node for the following normalized
 * cross-platform "gesture" events:
 * - `down` - mouse or touch went down
 * - `up` - mouse or touch went up
 * - `tap` - mouse click or finger tap
 * - `track` - mouse drag or touch move
 *
 * @summary Module for adding cross-platform gesture event listeners.
 */
// detect native touch action support
let u="string"==typeof document.head.style.touchAction,c="__polymerGesturesHandled",l="__polymerGesturesTouchAction",d=["mousedown","mousemove","mouseup","click"],a=[0,1,4,2],h=function(){try{return 1===new MouseEvent("test",{buttons:1}).buttons}catch(t){return!1}}();
/**
 * @param {string} name Possible mouse event name
 * @return {boolean} true if mouse event, false if not
 */
function f(t){return d.indexOf(t)>-1}
/* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
// check for passive event listeners
let m=!1;
/**
 * Generate settings for event listeners, dependant on `passiveTouchGestures`
 *
 * @param {string} eventName Event name to determine if `{passive}` option is
 *   needed
 * @return {{passive: boolean} | undefined} Options to use for addEventListener
 *   and removeEventListener
 */
function p(t){if(!f(t)&&"touchend"!==t)return u&&m&&s.i?{passive:!0}:void 0}// Check for touch-only devices
!function(){try{let t=Object.defineProperty({},"passive",{get(){m=!0}});window.addEventListener("test",null,t),window.removeEventListener("test",null,t)}catch(t){}}();let v=navigator.userAgent.match(/iP(?:[oa]d|hone)|Android/);// keep track of any labels hit by the mouseCanceller
/** @type {!Array<!HTMLLabelElement>} */const _=[],g={button:!0,input:!0,keygen:!0,meter:!0,output:!0,textarea:!0,progress:!0,select:!0},y={button:!0,command:!0,fieldset:!0,input:!0,keygen:!0,optgroup:!0,option:!0,select:!0,textarea:!0};
/** @type {!Object<boolean>} */
/**
 * @param {HTMLElement} el Element that may be labelled.
 * @return {!Array<!HTMLLabelElement>} Relevant label for `el`
 */
function b(t){let e=Array.prototype.slice.call(
/** @type {HTMLInputElement} */
t.labels||[]);// IE doesn't have `labels` and Safari doesn't populate `labels`
// if element is in a shadowroot.
// In this instance, finding the non-ancestor labels is enough,
// as the mouseCancellor code will handle ancstor labels
if(!e.length){e=[];let n=t.getRootNode();// if there is an id on `el`, check for all labels with a matching `for` attribute
if(t.id){let o=n.querySelectorAll(`label[for = ${t.id}]`);for(let t=0;t<o.length;t++)e.push(
/** @type {!HTMLLabelElement} */
o[t])}}return e}// touch will make synthetic mouse events
// `preventDefault` on touchend will cancel them,
// but this breaks `<input>` focus and link clicks
// disable mouse handlers for MOUSE_TIMEOUT ms after
// a touchend to ignore synthetic mouse events
let w=function(t){
// Check for sourceCapabilities, used to distinguish synthetic events
// if mouseEvent did not come from a device that fires touch events,
// it was made by a real mouse and should be counted
// http://wicg.github.io/InputDeviceCapabilities/#dom-inputdevicecapabilities-firestouchevents
let e=t.sourceCapabilities;
/**
 * @param {HTMLElement} el Element to check labelling status
 * @return {boolean} element can have labels
 */
var n;if((!e||e.firesTouchEvents)&&(// skip synthetic mouse events
t[c]={skip:!0},"click"===t.type)){let e=!1,o=E(t);for(let t=0;t<o.length;t++){if(o[t].nodeType===Node.ELEMENT_NODE)if("label"===o[t].localName)_.push(
/** @type {!HTMLLabelElement} */
o[t]);else if(n=
/** @type {!HTMLElement} */
o[t],g[n.localName]){let n=b(
/** @type {!HTMLElement} */
o[t]);// check if one of the clicked labels is labelling this element
for(let t=0;t<n.length;t++)e=e||_.indexOf(n[t])>-1}if(o[t]===x.mouse.target)return}// if one of the clicked labels was labelling the target element,
// this is not a ghost click
if(e)return;t.preventDefault(),t.stopPropagation()}};
/**
 * @param {boolean=} setup True to add, false to remove.
 * @return {void}
 */function S(t){let e=v?["click"]:d;for(let n,o=0;o<e.length;o++)n=e[o],t?(
// reset clickLabels array
_.length=0,document.addEventListener(n,w,!0)):document.removeEventListener(n,w,!0)}
/**
 * @param {MouseEvent} ev event to test for left mouse button down
 * @return {boolean} has left mouse button down
 */
function O(t){let e=t.type;// exit early if the event is not a mouse event
if(!f(e))return!1;// ev.button is not reliable for mousemove (0 is overloaded as both left button and no buttons)
// instead we use ev.buttons (bitmask of buttons) or fall back to ev.which (deprecated, 0 for no buttons, 1 for left button)
if("mousemove"===e){
// allow undefined for testing events
let e=void 0===t.buttons?1:t.buttons;// buttons is a bitmask, check that the left button bit is set (1)
return t instanceof window.MouseEvent&&!h&&(e=a[t.which]||0),Boolean(1&e)}// ev.button is 0 in mousedown/mouseup/click for left button activation
return 0===(void 0===t.button?0:t.button)}let x={mouse:{target:null,mouseIgnoreJob:null},touch:{x:0,y:0,id:-1,scrollDecided:!1}};function M(t,e,n){t.movefn=e,t.upfn=n,document.addEventListener("mousemove",e),document.addEventListener("mouseup",n)}function N(t){document.removeEventListener("mousemove",t.movefn),document.removeEventListener("mouseup",t.upfn),t.movefn=null,t.upfn=null}s.b&&
// use a document-wide touchend listener to start the ghost-click prevention mechanism
// Use passive event listeners, if supported, to not affect scrolling performance
document.addEventListener("touchend",(function(t){if(!s.b)return;x.mouse.mouseIgnoreJob||S(!0),x.mouse.target=E(t)[0],x.mouse.mouseIgnoreJob=i.a.debounce(x.mouse.mouseIgnoreJob,o.d.after(2500),(function(){S(),x.mouse.target=null,x.mouse.mouseIgnoreJob=null}))}),!!m&&{passive:!0})
/**
 * Returns the composedPath for the given event.
 * @param {Event} event to process
 * @return {!Array<!EventTarget>} Path of the event
 */;const E=window.ShadyDOM&&window.ShadyDOM.noPatch?window.ShadyDOM.composedPath:t=>t.composedPath&&t.composedPath()||[]
/** @type {!Object<string, !GestureRecognizer>} */,k={},C=[];
/**
 * a cheaper check than ev.composedPath()[0];
 *
 * @private
 * @param {Event|Touch} ev Event.
 * @return {EventTarget} Returns the event target.
 */
function L(t){const e=E(
/** @type {?Event} */
t);// It shouldn't be, but sometimes path is empty (window on Safari).
return e.length>0?e[0]:t.target}
/**
 * @private
 * @param {Event} ev Event.
 * @return {void}
 */function A(t){let e,n=t.type,o=t.currentTarget.__polymerGestures;if(!o)return;let i=o[n];if(i){if(!t[c]&&(t[c]={},"touch"===n.slice(0,5))){// eslint-disable-line no-self-assign
let e=(t=
/** @type {TouchEvent} */
t).changedTouches[0];if("touchstart"===n&&1===t.touches.length&&(x.touch.id=e.identifier),x.touch.id!==e.identifier)return;u||"touchstart"!==n&&"touchmove"!==n||
/**
 * @private
 * @param {TouchEvent} ev Event.
 * @return {void}
 */
function(t){let e=t.changedTouches[0],n=t.type;if("touchstart"===n)x.touch.x=e.clientX,x.touch.y=e.clientY,x.touch.scrollDecided=!1;else if("touchmove"===n){if(x.touch.scrollDecided)return;x.touch.scrollDecided=!0;let n=function(t){let e="auto",n=E(t);for(let t,o=0;o<n.length;o++)if(t=n[o],t[l]){e=t[l];break}return e}(t),o=!1,i=Math.abs(x.touch.x-e.clientX),s=Math.abs(x.touch.y-e.clientY);t.cancelable&&("none"===n?o=!0:"pan-x"===n?o=s>i:"pan-y"===n&&(o=i>s)),o?t.preventDefault():X("track")}}
/**
 * Adds an event listener to a node for the given gesture type.
 *
 * @param {!EventTarget} node Node to add listener on
 * @param {string} evType Gesture type: `down`, `up`, `track`, or `tap`
 * @param {!function(!Event):void} handler Event listener function to call
 * @return {boolean} Returns true if a gesture event listener was added.
 */(t)}// used to ignore synthetic mouse events
if(e=t[c],!e.skip){// reset recognizer state
for(let n,o=0;o<C.length;o++)n=C[o],i[n.name]&&!e[n.name]&&n.flow&&n.flow.start.indexOf(t.type)>-1&&n.reset&&n.reset();// enforce gesture recognizer order
for(let o,s=0;s<C.length;s++)o=C[s],i[o.name]&&!e[o.name]&&(e[o.name]=!0,o[n](t))}}}function D(t,e,n){return!!k[e]&&(
/**
 * automate the event listeners for the native events
 *
 * @private
 * @param {!EventTarget} node Node on which to add the event.
 * @param {string} evType Event type to add.
 * @param {function(!Event)} handler Event handler function.
 * @return {void}
 */
function(t,e,n){let o=k[e],i=o.deps,s=o.name,r=t.__polymerGestures;r||(t.__polymerGestures=r={});for(let e,n,o=0;o<i.length;o++)e=i[o],// don't add mouse handlers on iOS because they cause gray selection overlays
v&&f(e)&&"click"!==e||(n=r[e],n||(r[e]=n={_count:0}),0===n._count&&t.addEventListener(e,A,p(e)),n[s]=(n[s]||0)+1,n._count=(n._count||0)+1);t.addEventListener(e,n),o.touchAction&&Y(t,o.touchAction)}
/**
 * automate event listener removal for native events
 *
 * @private
 * @param {!EventTarget} node Node on which to remove the event.
 * @param {string} evType Event type to remove.
 * @param {function(!Event): void} handler Event handler function.
 * @return {void}
 */(t,e,n),!0)}
/**
 * Removes an event listener from a node for the given gesture type.
 *
 * @param {!EventTarget} node Node to remove listener from
 * @param {string} evType Gesture type: `down`, `up`, `track`, or `tap`
 * @param {!function(!Event):void} handler Event listener function previously passed to
 *  `addListener`.
 * @return {boolean} Returns true if a gesture event listener was removed.
 */function j(t,e,n){return!!k[e]&&(function(t,e,n){let o=k[e],i=o.deps,s=o.name,r=t.__polymerGestures;if(r)for(let e,n,o=0;o<i.length;o++)e=i[o],n=r[e],n&&n[s]&&(n[s]=(n[s]||1)-1,n._count=(n._count||1)-1,0===n._count&&t.removeEventListener(e,A,p(e)));t.removeEventListener(e,n)}
/**
 * Registers a new gesture event recognizer for adding new custom
 * gesture event types.
 *
 * @param {!GestureRecognizer} recog Gesture recognizer descriptor
 * @return {void}
 */(t,e,n),!0)}function T(t){C.push(t);for(let e=0;e<t.emits.length;e++)k[t.emits[e]]=t}
/**
 * @private
 * @param {string} evName Event name.
 * @return {Object} Returns the gesture for the given event name.
 */
/**
 * Sets scrolling direction on node.
 *
 * This value is checked on first move, thus it should be called prior to
 * adding event listeners.
 *
 * @param {!EventTarget} node Node to set touch action setting on
 * @param {string} value Touch action value
 * @return {void}
 */
function Y(t,e){u&&t instanceof HTMLElement&&
// NOTE: add touchAction async so that events can be added in
// custom element constructors. Otherwise we run afoul of custom
// elements restriction against settings attributes (style) in the
// constructor.
o.c.run(()=>{t.style.touchAction=e}),t[l]=e}
/**
 * Dispatches an event on the `target` element of `type` with the given
 * `detail`.
 * @private
 * @param {!EventTarget} target The element on which to fire an event.
 * @param {string} type The type of event to fire.
 * @param {!Object=} detail The detail object to populate on the event.
 * @return {void}
 */function R(t,e,n){let o=new Event(e,{bubbles:!0,cancelable:!0,composed:!0});// forward `preventDefault` in a clean way
if(o.detail=n,Object(r.a)(
/** @type {!Node} */
t).dispatchEvent(o),o.defaultPrevented){let t=n.preventer||n.sourceEvent;t&&t.preventDefault&&t.preventDefault()}}
/**
 * Prevents the dispatch and default action of the given event name.
 *
 * @param {string} evName Event name.
 * @return {void}
 */function X(t){let e=function(t){for(let e,n=0;n<C.length;n++){e=C[n];for(let n,o=0;o<e.emits.length;o++)if(n=e.emits[o],n===t)return e}return null}(t);e.info&&(e.info.prevent=!0)}
/**
 * Reset the 2500ms timeout on processing mouse input after detecting touch input.
 *
 * Touch inputs create synthesized mouse inputs anywhere from 0 to 2000ms after the touch.
 * This method should only be called during testing with simulated touch inputs.
 * Calling this method in production may cause duplicate taps or other Gestures.
 *
 * @return {void}
 */function P(){x.mouse.mouseIgnoreJob&&x.mouse.mouseIgnoreJob.flush()}
/* eslint-disable valid-jsdoc */
/**
 * @param {string} type
 * @param {EventTarget} target
 * @param {Event|Touch} event
 * @param {Event=} preventer
 * @return {void}
 */
function Z(t,e,n,o){e&&R(e,t,{x:n.clientX,y:n.clientY,sourceEvent:n,preventer:o,prevent:function(t){return X(t)}})}
/**
 * @param {!GestureInfo} info
 * @param {number} x
 * @param {number} y
 * @return {boolean}
 */
function J(t,e,n){if(t.prevent)return!1;if(t.started)return!0;let o=Math.abs(t.x-e),i=Math.abs(t.y-n);return o>=5||i>=5}
/**
 * @param {!GestureInfo} info
 * @param {?EventTarget} target
 * @param {Touch} touch
 * @return {void}
 */function B(t,e,n){if(!e)return;let o,i=t.moves[t.moves.length-2],s=t.moves[t.moves.length-1],r=s.x-t.x,u=s.y-t.y,c=0;i&&(o=s.x-i.x,c=s.y-i.y),R(e,"track",{state:t.state,x:n.clientX,y:n.clientY,dx:r,dy:u,ddx:o,ddy:c,sourceEvent:n,hover:function(){
/**
 * Finds the element rendered on the screen at the provided coordinates.
 *
 * Similar to `document.elementFromPoint`, but pierces through
 * shadow roots.
 *
 * @param {number} x Horizontal pixel coordinate
 * @param {number} y Vertical pixel coordinate
 * @return {Element} Returns the deepest shadowRoot inclusive element
 * found at the screen position given.
 */
return function(t,e){let n=document.elementFromPoint(t,e),o=n;// this code path is only taken when native ShadowDOM is used
// if there is a shadowroot, it may have a node at x/y
// if there is not a shadowroot, exit the loop
for(;o&&o.shadowRoot&&!window.ShadyDOM;){
// if there is a node at x/y in the shadowroot, look deeper
let i=o;// on Safari, elementFromPoint may return the shadowRoot host
if(o=o.shadowRoot.elementFromPoint(t,e),i===o)break;o&&(n=o)}return n}(n.clientX,n.clientY)}})}
/**
 * @param {!GestureInfo} info
 * @param {Event | Touch} e
 * @param {Event=} preventer
 * @return {void}
 */
function G(t,e,n){let o=Math.abs(e.clientX-t.x),i=Math.abs(e.clientY-t.y),s=L(n||e);!s||y[
/** @type {!HTMLElement} */
s.localName]&&s.hasAttribute("disabled")||// dx,dy can be NaN if `click` has been simulated and there was no `down` for `start`
(isNaN(o)||isNaN(i)||o<=25&&i<=25||function(t){if("click"===t.type){
// ev.detail is 0 for HTMLElement.click in most browsers
if(0===t.detail)return!0;// in the worst case, check that the x/y position of the click is within
// the bounding box of the target of the event
// Thanks IE 10 >:(
let e=L(t);// make sure the target of the event is an element so we can use getBoundingClientRect,
// if not, just assume it is a synthetic click
if(!e.nodeType||
/** @type {Element} */
e.nodeType!==Node.ELEMENT_NODE)return!0;let n=
/** @type {Element} */
e.getBoundingClientRect(),o=t.pageX,i=t.pageY;// use page x/y to account for scrolling
// ev is a synthetic click if the position is outside the bounding box of the target
return!(o>=n.left&&o<=n.right&&i>=n.top&&i<=n.bottom)}return!1}(e))&&(
// prevent taps from being generated if an event has canceled them
t.prevent||R(s,"tap",{x:e.clientX,y:e.clientY,sourceEvent:e,preventer:n}))}
/* eslint-enable valid-jsdoc */
/** @deprecated */T({name:"downup",deps:["mousedown","touchstart","touchend"],flow:{start:["mousedown","touchstart"],end:["mouseup","touchend"]},emits:["down","up"],info:{movefn:null,upfn:null},
/**
   * @this {GestureRecognizer}
   * @return {void}
   */
reset:function(){N(this.info)},
/**
   * @this {GestureRecognizer}
   * @param {MouseEvent} e
   * @return {void}
   */
mousedown:function(t){if(!O(t))return;let e=L(t),n=this;M(this.info,(function(t){O(t)||(Z("up",e,t),N(n.info))}),(function(t){O(t)&&Z("up",e,t),N(n.info)})),Z("down",e,t)},
/**
   * @this {GestureRecognizer}
   * @param {TouchEvent} e
   * @return {void}
   */
touchstart:function(t){Z("down",L(t),t.changedTouches[0],t)},
/**
   * @this {GestureRecognizer}
   * @param {TouchEvent} e
   * @return {void}
   */
touchend:function(t){Z("up",L(t),t.changedTouches[0],t)}}),T({name:"track",touchAction:"none",deps:["mousedown","touchstart","touchmove","touchend"],flow:{start:["mousedown","touchstart"],end:["mouseup","touchend"]},emits:["track"],info:{x:0,y:0,state:"start",started:!1,moves:[],
/** @this {GestureInfo} */
addMove:function(t){this.moves.length>2&&this.moves.shift(),this.moves.push(t)},movefn:null,upfn:null,prevent:!1},
/**
   * @this {GestureRecognizer}
   * @return {void}
   */
reset:function(){this.info.state="start",this.info.started=!1,this.info.moves=[],this.info.x=0,this.info.y=0,this.info.prevent=!1,N(this.info)},
/**
   * @this {GestureRecognizer}
   * @param {MouseEvent} e
   * @return {void}
   */
mousedown:function(t){if(!O(t))return;let e=L(t),n=this,o=function(t){let o=t.clientX,i=t.clientY;J(n.info,o,i)&&(
// first move is 'start', subsequent moves are 'move', mouseup is 'end'
n.info.state=n.info.started?"mouseup"===t.type?"end":"track":"start","start"===n.info.state&&
// if and only if tracking, always prevent tap
X("tap"),n.info.addMove({x:o,y:i}),O(t)||(
// always fire "end"
n.info.state="end",N(n.info)),e&&B(n.info,e,t),n.info.started=!0)};// add temporary document listeners as mouse retargets
M(this.info,o,(function(t){n.info.started&&o(t),// remove the temporary listeners
N(n.info)})),this.info.x=t.clientX,this.info.y=t.clientY},
/**
   * @this {GestureRecognizer}
   * @param {TouchEvent} e
   * @return {void}
   */
touchstart:function(t){let e=t.changedTouches[0];this.info.x=e.clientX,this.info.y=e.clientY},
/**
   * @this {GestureRecognizer}
   * @param {TouchEvent} e
   * @return {void}
   */
touchmove:function(t){let e=L(t),n=t.changedTouches[0],o=n.clientX,i=n.clientY;J(this.info,o,i)&&("start"===this.info.state&&
// if and only if tracking, always prevent tap
X("tap"),this.info.addMove({x:o,y:i}),B(this.info,e,n),this.info.state="track",this.info.started=!0)},
/**
   * @this {GestureRecognizer}
   * @param {TouchEvent} e
   * @return {void}
   */
touchend:function(t){let e=L(t),n=t.changedTouches[0];// only trackend if track was started and not aborted
this.info.started&&(
// reset started state on up
this.info.state="end",this.info.addMove({x:n.clientX,y:n.clientY}),B(this.info,e,n))}}),T({name:"tap",deps:["mousedown","click","touchstart","touchend"],flow:{start:["mousedown","touchstart"],end:["click","touchend"]},emits:["tap"],info:{x:NaN,y:NaN,prevent:!1},
/**
   * @this {GestureRecognizer}
   * @return {void}
   */
reset:function(){this.info.x=NaN,this.info.y=NaN,this.info.prevent=!1},
/**
   * @this {GestureRecognizer}
   * @param {MouseEvent} e
   * @return {void}
   */
mousedown:function(t){O(t)&&(this.info.x=t.clientX,this.info.y=t.clientY)},
/**
   * @this {GestureRecognizer}
   * @param {MouseEvent} e
   * @return {void}
   */
click:function(t){O(t)&&G(this.info,t)},
/**
   * @this {GestureRecognizer}
   * @param {TouchEvent} e
   * @return {void}
   */
touchstart:function(t){const e=t.changedTouches[0];this.info.x=e.clientX,this.info.y=e.clientY},
/**
   * @this {GestureRecognizer}
   * @param {TouchEvent} e
   * @return {void}
   */
touchend:function(t){G(this.info,t.changedTouches[0],t)}})},
/***/o5Wi:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return s}));
/* unused harmony export htmlLiteral */
/* harmony import */n("SRZj");
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/**
 * Class representing a static string value which can be used to filter
 * strings by asseting that they have been created via this class. The
 * `value` property returns the string passed to the constructor.
 */class o{constructor(t){
/** @type {string} */
this.value=t.toString()}
/**
   * @return {string} LiteralString string value
   * @override
   */toString(){return this.value}}
/**
 * @param {*} value Object to stringify into HTML
 * @return {string} HTML stringified form of `obj`
 */function i(t){if(t instanceof o)
/** @type {!LiteralString} */
return t.value;throw new Error("non-literal value passed to Polymer's htmlLiteral function: "+t)}
/**
 * @param {*} value Object to stringify into HTML
 * @return {string} HTML stringified form of `obj`
 */
/**
 * A template literal tag that creates an HTML <template> element from the
 * contents of the string.
 *
 * This allows you to write a Polymer Template in JavaScript.
 *
 * Templates can be composed by interpolating `HTMLTemplateElement`s in
 * expressions in the JavaScript template literal. The nested template's
 * `innerHTML` is included in the containing template.  The only other
 * values allowed in expressions are those returned from `htmlLiteral`
 * which ensures only literal values from JS source ever reach the HTML, to
 * guard against XSS risks.
 *
 * All other values are disallowed in expressions to help prevent XSS
 * attacks; however, `htmlLiteral` can be used to compose static
 * string values into templates. This is useful to compose strings into
 * places that do not accept html, like the css text of a `style`
 * element.
 *
 * Example:
 *
 *     static get template() {
 *       return html`
 *         <style>:host{ content:"..." }</style>
 *         <div class="shadowed">${this.partialTemplate}</div>
 *         ${super.template}
 *       `;
 *     }
 *     static get partialTemplate() { return html`<span>Partial!</span>`; }
 *
 * @param {!ITemplateArray} strings Constant parts of tagged template literal
 * @param {...*} values Variable parts of tagged template literal
 * @return {!HTMLTemplateElement} Constructed HTMLTemplateElement
 */
const s=function(t,...e){const n=
/** @type {!HTMLTemplateElement} */
document.createElement("template");return n.innerHTML=e.reduce((e,n,s)=>e+function(t){if(t instanceof HTMLTemplateElement)
/** @type {!HTMLTemplateElement } */
return t.innerHTML;if(t instanceof o)return i(t);throw new Error("non-template value passed to Polymer's html function: "+t)}(n)+t[s+1],t[0]),n};
/**
 * An html literal tag that can be used with `html` to compose.
 * a literal string.
 *
 * Example:
 *
 *     static get template() {
 *       return html`
 *         <style>
 *           :host { display: block; }
 *           ${this.styleTemplate()}
 *         </style>
 *         <div class="shadowed">${staticValue}</div>
 *         ${super.template}
 *       `;
 *     }
 *     static get styleTemplate() {
 *        return htmlLiteral`.shadowed { background: gray; }`;
 *     }
 *
 * @param {!ITemplateArray} strings Constant parts of tagged template literal
 * @param {...*} values Variable parts of tagged template literal
 * @return {!LiteralString} Constructed literal string
 */},
/***/tZcj:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"d",(function(){return o})),
/* harmony export (binding) */n.d(e,"g",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return s})),
/* harmony export (binding) */n.d(e,"c",(function(){return r})),
/* harmony export (binding) */n.d(e,"i",(function(){return u})),
/* harmony export (binding) */n.d(e,"e",(function(){return c})),
/* harmony export (binding) */n.d(e,"f",(function(){return l})),
/* unused harmony export split */
/* harmony export (binding) */n.d(e,"a",(function(){return a})),
/* harmony export (binding) */n.d(e,"h",(function(){return h}));
/* unused harmony export isDeep */
/* harmony import */n("SRZj");
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
/**
 * Module with utilities for manipulating structured data path strings.
 *
 * @summary Module with utilities for manipulating structured data path strings.
 */
/**
 * Returns true if the given string is a structured data path (has dots).
 *
 * Example:
 *
 * ```
 * isPath('foo.bar.baz') // true
 * isPath('foo')         // false
 * ```
 *
 * @param {string} path Path string
 * @return {boolean} True if the string contained one or more dots
 */function o(t){return t.indexOf(".")>=0}
/**
 * Returns the root property name for the given path.
 *
 * Example:
 *
 * ```
 * root('foo.bar.baz') // 'foo'
 * root('foo')         // 'foo'
 * ```
 *
 * @param {string} path Path string
 * @return {string} Root property name
 */function i(t){let e=t.indexOf(".");return-1===e?t:t.slice(0,e)}
/**
 * Given `base` is `foo.bar`, `foo` is an ancestor, `foo.bar` is not
 * Returns true if the given path is an ancestor of the base path.
 *
 * Example:
 *
 * ```
 * isAncestor('foo.bar', 'foo')         // true
 * isAncestor('foo.bar', 'foo.bar')     // false
 * isAncestor('foo.bar', 'foo.bar.baz') // false
 * ```
 *
 * @param {string} base Path string to test against.
 * @param {string} path Path string to test.
 * @return {boolean} True if `path` is an ancestor of `base`.
 */function s(t,e){
//     base.startsWith(path + '.');
return 0===t.indexOf(e+".")}
/**
 * Given `base` is `foo.bar`, `foo.bar.baz` is an descendant
 *
 * Example:
 *
 * ```
 * isDescendant('foo.bar', 'foo.bar.baz') // true
 * isDescendant('foo.bar', 'foo.bar')     // false
 * isDescendant('foo.bar', 'foo')         // false
 * ```
 *
 * @param {string} base Path string to test against.
 * @param {string} path Path string to test.
 * @return {boolean} True if `path` is a descendant of `base`.
 */function r(t,e){
//     path.startsWith(base + '.');
return 0===e.indexOf(t+".")}
/**
 * Replaces a previous base path with a new base path, preserving the
 * remainder of the path.
 *
 * User must ensure `path` has a prefix of `base`.
 *
 * Example:
 *
 * ```
 * translate('foo.bar', 'zot', 'foo.bar.baz') // 'zot.baz'
 * ```
 *
 * @param {string} base Current base string to remove
 * @param {string} newBase New base string to replace with
 * @param {string} path Path to translate
 * @return {string} Translated string
 */function u(t,e,n){return e+n.slice(t.length)}
/**
 * @param {string} base Path string to test against
 * @param {string} path Path string to test
 * @return {boolean} True if `path` is equal to `base`
 */function c(t,e){return t===e||s(t,e)||r(t,e)}
/**
 * Converts array-based paths to flattened path.  String-based paths
 * are returned as-is.
 *
 * Example:
 *
 * ```
 * normalize(['foo.bar', 0, 'baz'])  // 'foo.bar.0.baz'
 * normalize('foo.bar.0.baz')        // 'foo.bar.0.baz'
 * ```
 *
 * @param {string | !Array<string|number>} path Input path
 * @return {string} Flattened path
 */function l(t){if(Array.isArray(t)){let e=[];for(let n=0;n<t.length;n++){let o=t[n].toString().split(".");for(let t=0;t<o.length;t++)e.push(o[t])}return e.join(".")}return t}
/**
 * Splits a path into an array of property names. Accepts either arrays
 * of path parts or strings.
 *
 * Example:
 *
 * ```
 * split(['foo.bar', 0, 'baz'])  // ['foo', 'bar', '0', 'baz']
 * split('foo.bar.0.baz')        // ['foo', 'bar', '0', 'baz']
 * ```
 *
 * @param {string | !Array<string|number>} path Input path
 * @return {!Array<string>} Array of path parts
 * @suppress {checkTypes}
 */function d(t){return Array.isArray(t)?l(t).split("."):t.toString().split(".")}
/**
 * Reads a value from a path.  If any sub-property in the path is `undefined`,
 * this method returns `undefined` (will never throw.
 *
 * @param {Object} root Object from which to dereference path from
 * @param {string | !Array<string|number>} path Path to read
 * @param {Object=} info If an object is provided to `info`, the normalized
 *  (flattened) path will be set to `info.path`.
 * @return {*} Value at path, or `undefined` if the path could not be
 *  fully dereferenced.
 */function a(t,e,n){let o=t,i=d(e);// Loop over path parts[0..n-1] and dereference
for(let t=0;t<i.length;t++){if(!o)return;o=o[i[t]]}return n&&(n.path=i.join(".")),o}
/**
 * Sets a value to a path.  If any sub-property in the path is `undefined`,
 * this method will no-op.
 *
 * @param {Object} root Object from which to dereference path from
 * @param {string | !Array<string|number>} path Path to set
 * @param {*} value Value to set to path
 * @return {string | undefined} The normalized version of the input path
 */function h(t,e,n){let o=t,i=d(e),s=i[i.length-1];if(i.length>1){
// Loop over path parts[0..n-2] and dereference
for(let t=0;t<i.length-1;t++){if(o=o[i[t]],!o)return}// Set value to object at end of path
o[s]=n}else
// Simple property set
o[e]=n;return i.join(".")}
/**
 * Returns true if the given string is a structured data path (has dots).
 *
 * This function is deprecated.  Use `isPath` instead.
 *
 * Example:
 *
 * ```
 * isDeep('foo.bar.baz') // true
 * isDeep('foo')         // false
 * ```
 *
 * @deprecated
 * @param {string} path Path string
 * @return {boolean} True if the string contained one or more dots
 */}}]);